import { memo, useContext } from "react";
import PropTypes from "prop-types";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import AppGlobalsContext from "app/AppGlobalsContext";
import "./FaqHomeCategory.scss";
import { FormattedMessage } from "react-intl";
import Button, {
	BUTTON_ICON_ALIGNMENTS,
	BUTTON_SIZES,
	BUTTON_VARIANTS,
} from "app/pages/.shared/form/Button";

const IMG_SIZES = {
	large: { width: 241, height: 120 },
	xlarge: { width: 241, height: 120 },
	medium: { width: 710, height: 354 },
	small: { width: 500, height: 249 },
};

const FaqHomeCategory = ({
	categoryId,
	categoryName,
	categoryPicture,
	categoryThumbnail,
	subCategories,
}) => {
	const { resolution } = useContext(AppGlobalsContext);

	const subCategoriestoDisplay = subCategories.slice(0, 4);

	return (
		<div className="faq-home-category">
			<div className="faq-home-category__picture">
				<BackgroundProgressiveImg
					src={categoryPicture}
					thumbnail={categoryThumbnail}
					resolution={resolution}
					sizes={IMG_SIZES}
				/>
			</div>
			<div className="faq-home-category__content">
				<div className="faq-home-category__name">
					<Button
						variant={BUTTON_VARIANTS.LINK}
						size={BUTTON_SIZES.LARGE}
						to={{
							pathname: `/faq/category/${categoryId}`,
						}}
						className="faq-home-category__link"
						icon={<i className="icon icon--chevron" />}
						label={categoryName}
					/>
				</div>
				<div className="faq-home-category__subcategories">
					{subCategoriestoDisplay.map(subCategory => {
						return (
							<div key={subCategory.id} className="faq-home-category__subcategory">
								<Button
									variant={BUTTON_VARIANTS.LINK}
									siaze={BUTTON_SIZES.SMALL}
									to={{
										pathname: `/faq/category/${categoryId}/subcategory/${
											subCategory.id
										}`,
									}}
									className="faq-home-category__link"
									label={subCategory.name}
								/>
							</div>
						);
					})}
				</div>
				<div className="faq-home-category__see-all">
					<Button
						variant={BUTTON_VARIANTS.LINK}
						size={BUTTON_SIZES.SMALL}
						to={{ pathname: `/faq/category/${categoryId}` }}
						icon={<i className="icon icon--chevron" />}
						alignIcon={BUTTON_ICON_ALIGNMENTS.RIGHT}
						label={<FormattedMessage id="faq.home.categories.see.all" />}
					/>
				</div>
			</div>
		</div>
	);
};

FaqHomeCategory.propTypes = {
	categoryId: PropTypes.string,
	categoryPicture: PropTypes.string,
	categoryThumbnail: PropTypes.string,
	categoryName: PropTypes.string,
	subCategories: PropTypes.array,
};

FaqHomeCategory.defaultProps = {
	subCategories: [],
	categoryPicture:
		"https://res.cloudinary.com/perfectstay/image/upload/v1607722775/asset/DESK_cat-generique.jpg",
	categoryThumbnail:
		"/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAgICAgJCAkKCgkNDgwODRMSEBASEx0VFhUWFR0sHCAcHCAcLCcvJiQmLydGNzExN0ZRREBEUWJYWGJ8dnyiotkBCAgICAkICQoKCQ0ODA4NExIQEBITHRUWFRYVHSwcIBwcIBwsJy8mJCYvJ0Y3MTE3RlFEQERRYlhYYnx2fKKi2f/AABEIABkAMgMBIgACEQEDEQH/xABpAAACAgMBAAAAAAAAAAAAAAACBgABAwQFBxAAAgICAgMBAAAAAAAAAAAAAAECAwURBCESMTQTAQADAQEBAAAAAAAAAAAAAAAAAwQCAQURAAMBAQADAQAAAAAAAAAAAAABAhEDEiExUf/aAAwDAQACEQMRAD8A5uJyd1nJipSPRIz3FCBjsPdTdGTHuppRSZJfi2etyfSYer2ZfIvZrt7mZNiniZXG1KbDbB2C2Ds4MSMmyAbIAYKfIyd1NzTj0bfEy9Vz1vs0Mn7mL2L+qQ7E0yfXNJfdHiGRjK/8zrKXQn0faNkfSFWsw3xp0nv6G2TYJaMFARCiGgP/2Q==",
};

export default memo(FaqHomeCategory);
